import classNames from 'classnames';
import React from 'react';
import eye from './icons/eye.json';
import gear from './icons/gear.json';
import magnifier from './icons/magnifier.json';
import message from './icons/message.json';
import rocket from './icons/rocket.json';
import { Lottie } from '@crello/react-lottie';

const RoadCard = props => {
  const { cardClass, dashed, firstSectionClass, firstSectionText, headerText, text } = props;

  const icons = {
    eye,
    gear,
    magnifier,
    message,
    rocket,
  };

  return (
    <div className={classNames('flex flex-row justify-center gap-[27px] md:gap-[32px] relative h-full', cardClass)}>
      {dashed && <div className="w-[1px] h-full border-l-1 border-[#979797] border-dashed absolute z-20 left-[30px]"></div>}
      <div
        className={classNames(
          'relative z-20 flex items-center p-[14px] justify-center w-[63px] h-[63px] rounded-[5px] border-1 shadow-[7px_7px_10.3px_0px_rgba(0,0,0,0.27)_inset,-10px_-5px_7px_0px_rgba(255,255,255,0.56)_inset,2px_-8px_7px_0px_rgba(255,255,255,0.56)_inset]  bg-[#F5F5F5]',
          firstSectionClass
        )}
      >
        <Lottie
          width={35}
          height={35}
          config={{
            animationData: icons[firstSectionText],
            loop: true,
            autoPlay: true,
          }}
          playingState="playing"
        />
      </div>

      <div className={classNames('flex flex-col gap-[24px] pb-[48px]')}>
        <h3 className="text-[24px] font-[500] leading-[29px]">{headerText}</h3>
        <p className="text-[14px] font-[300] leading-[17px]">{text}</p>
      </div>
    </div>
  );
};

export default RoadCard;
